export default "__VITE_PUBLIC_ASSET__c776c167__"